import axios from 'axios'

import type { WebshopPackage } from '../../../schema/webshop-package'
import { getApiUrl, PAYMENT_WEBSHOP_URL } from '../../util/api/api'

const removeProductFromBasket = (product: WebshopPackage) =>
  axios.post<{ productId: string } | string>(
    getApiUrl(`${PAYMENT_WEBSHOP_URL}/removeFromBasket`),
    {
      productId: product.productCode,
    },
    { withCredentials: true },
  )

export default removeProductFromBasket
